// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"511b40ee","885":"8ededa54"}[chunkId] + ".chunk.js";
};